// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.containerFilters {
  display: flex;
  flex-wrap: wrap;
  flex-direction: row;
  gap: 10px;
}

.css-8rwjl-MuiInputBase-root-MuiFilledInput-root.Mui-focused,
.css-1iqa30q-MuiFormControl-root-MuiTextField-root .MuiFilledInput-root {
  width: 22ch;
}

.MuiInputBase-root.MuiFilledInput-root.MuiFilledInput-underline.MuiInputBase-colorPrimary.Mui-focused.MuiInputBase-formControl.MuiInputBase-adornedEnd.css-10048ta-MuiInputBase-root-MuiFilledInput-root {
  width: 33.2ch;
  border-radius: 0% !important;
}

.MuiSelect-root {
  position: relative;
}

.MuiSelect-icon {
  position: absolute;
  right: 10px;
  top: 50%;
  transform: translateY(-50%);
}

.buttonLixo {
  display: flex;
  align-items: center;
  cursor: pointer;
  padding-left: 10px;
  width: 150px;
  height: 45px;
  justify-content: center;
}

.buttonLixo span {
  padding-left: 5px;
  font-size: 16px;
}

.buttonLixo:hover {
  background-color: #d1e4ff;
}

button.MuiButtonBase-root.MuiIconButton-root.MuiIconButton-sizeMedium.MuiAutocomplete-clearIndicator.css-1glvl0p-MuiButtonBase-root-MuiIconButton-root-MuiAutocomplete-clearIndicator {
  margin: 0px 0px 6.5px 0px !important;
}

.calendarInput {
  margin-left: 10px;
}

.positionError {
  position: relative;
  min-height: 30px;
  display: flex;
  align-items: center;
  font-size: 15px;
  justify-content: left;
  padding: 3px 10px;
}

@media (min-width: 100px) and (max-width: 670px) {
  .calendarInput {
    margin-left: 0px;
  }
}

@media (min-width: 952px) and (max-width: 1232px) {
  .calendarInput {
    margin-left: 0px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/componentes/fluxo-engenheiro/filters/filters.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,SAAS;AACX;;AAEA;;EAEE,WAAW;AACb;;AAEA;EACE,aAAa;EACb,4BAA4B;AAC9B;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,QAAQ;EACR,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,kBAAkB;EAClB,YAAY;EACZ,YAAY;EACZ,uBAAuB;AACzB;;AAEA;EACE,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,qBAAqB;EACrB,iBAAiB;AACnB;;AAEA;EACE;IACE,gBAAgB;EAClB;AACF;;AAEA;EACE;IACE,gBAAgB;EAClB;AACF","sourcesContent":[".containerFilters {\n  display: flex;\n  flex-wrap: wrap;\n  flex-direction: row;\n  gap: 10px;\n}\n\n.css-8rwjl-MuiInputBase-root-MuiFilledInput-root.Mui-focused,\n.css-1iqa30q-MuiFormControl-root-MuiTextField-root .MuiFilledInput-root {\n  width: 22ch;\n}\n\n.MuiInputBase-root.MuiFilledInput-root.MuiFilledInput-underline.MuiInputBase-colorPrimary.Mui-focused.MuiInputBase-formControl.MuiInputBase-adornedEnd.css-10048ta-MuiInputBase-root-MuiFilledInput-root {\n  width: 33.2ch;\n  border-radius: 0% !important;\n}\n\n.MuiSelect-root {\n  position: relative;\n}\n\n.MuiSelect-icon {\n  position: absolute;\n  right: 10px;\n  top: 50%;\n  transform: translateY(-50%);\n}\n\n.buttonLixo {\n  display: flex;\n  align-items: center;\n  cursor: pointer;\n  padding-left: 10px;\n  width: 150px;\n  height: 45px;\n  justify-content: center;\n}\n\n.buttonLixo span {\n  padding-left: 5px;\n  font-size: 16px;\n}\n\n.buttonLixo:hover {\n  background-color: #d1e4ff;\n}\n\nbutton.MuiButtonBase-root.MuiIconButton-root.MuiIconButton-sizeMedium.MuiAutocomplete-clearIndicator.css-1glvl0p-MuiButtonBase-root-MuiIconButton-root-MuiAutocomplete-clearIndicator {\n  margin: 0px 0px 6.5px 0px !important;\n}\n\n.calendarInput {\n  margin-left: 10px;\n}\n\n.positionError {\n  position: relative;\n  min-height: 30px;\n  display: flex;\n  align-items: center;\n  font-size: 15px;\n  justify-content: left;\n  padding: 3px 10px;\n}\n\n@media (min-width: 100px) and (max-width: 670px) {\n  .calendarInput {\n    margin-left: 0px;\n  }\n}\n\n@media (min-width: 952px) and (max-width: 1232px) {\n  .calendarInput {\n    margin-left: 0px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
